import styled from 'styled-components'
import { Query } from 'react-apollo'

import { hcData } from 'lib/CCAQuery'
import SimpleErrorPage from 'components/error/SimpleErrorPage'
import { FlexRowDiv, FlexDiv, Box, H1, P, A } from 'components/generic/HomePageComponents'
import allPostsQuery from 'components/api/queries/MainContainerQuery.gql'
import AboutUs from './AboutUs'
import Features from './Features'
import EasyEffectiveAffordable from './EasyEffectiveAffordable'
import Pricing from './Pricing'
import Reviews from './Reviews'

export const CCAButton = styled(A)`
  background-color: ${(props) => props.theme.colors.inverseColor};
  transition: background-color 0.5s ease;
  width: 200px;
  padding: 10px 48px;
  font-weight: bold;
  white-space: normal;
  font-size: ${(props) => props.theme.buttonTextSize};
  margin-top: 35px;
  border: 2px #fff solid;
  text-decoration: none;
  color: ${(props) => props.theme.buttonColor};
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.inverseColor};
    border-color: ${(props) => props.theme.colors.inverseColor};
  }
`

const HeroPanel = (props) => {
  const {
    data: {
      backgroundImageDesktop,
      backgroundImageMobile,
      header,
      body,
      buttonCta,
      buttonLink,
      jobSeeker,
      jobSeekerLink,
      jobSeekerLinkText,
    },
  } = props
  const desktopImageUrl = `url(${backgroundImageDesktop})`
  const mobileImageUrl = `url(${backgroundImageMobile})`
  return (
    <FlexRowDiv
      pt={['100px', '0px']}
      backgroundImage={[mobileImageUrl, desktopImageUrl]}
      backgroundPosition={['50% 0px', 'center center']}
      backgroundRepeat='no-repeat'
      backgroundSize='cover'
      borderBottom='1px grey solid'
      minHeight={['1200px', '600px']}
      className='CCA'
    >
      <FlexRowDiv
        justifyContent={['flex-start', 'flex-end']}
        ml={['0px', 'auto']}
        mr={['0px', 'auto']}
        maxWidth='1259px'
        flexDirection={['column', 'row']}
      >
        <FlexDiv
          flexDirection='column'
          width={['100%', '50%']}
          m='80px 0px 40px 40px'
          mt={['0px', '80px']}
        >
          <H1 fontSize='38px' mb='10px' lineHeight='1.2' maxWidth={['80vw', '']}>
            {header}
          </H1>
          <P maxWidth={['80vw', '550px']} fontSize='23px' lineHeight='1.3'>
            {body}
          </P>
          <Box textAlign={['left', 'left', 'left']} mt='20px'>
            <CCAButton href={buttonLink}>{buttonCta}</CCAButton>
            <Box display='flex' mt='40px' justifyContent={['flex-start', 'flex-start']}>
              <P fontSize='18px' mt='0px'>
                {jobSeeker}
              </P>
              <A color='inverseColor' fontSize='18px' href={jobSeekerLink}>
                {jobSeekerLinkText}
              </A>
            </Box>
          </Box>
        </FlexDiv>
      </FlexRowDiv>
    </FlexRowDiv>
  )
}
export default function CCAMainContainer(props) {
  return (
    <Query query={allPostsQuery} variables={{ domain: props.domain }}>
      {({ loading, error, data }) => {
        if (error) return <SimpleErrorPage />
        if (loading) return null
        return (
          <>
            <HeroPanel data={hcData.heroPanel} />
            <AboutUs data={hcData.aboutUs} />
            <Features data={hcData.features} />
            <EasyEffectiveAffordable data={hcData.easyEffectiveAffordable} />
            <Pricing data={hcData.pricing} wave={hcData.features.waveImage} />
            <Reviews data={hcData.reviews} wave={hcData.features.waveImage} />
          </>
        )
      }}
    </Query>
  )
}
